import { createContext, useContext, useEffect, useReducer } from "react";
import { NAV_REDUCER_GET_NAV_DATA } from "../common/constants";
import NavReducer from "../Reducers/NavReducer";
import { AuthContext } from "./AuthContext";

export const NavContext = createContext();

const NavContextProvider = (props) => {
	const [navData, dispatch] = useReducer(NavReducer, []);
	const { authData } = useContext(AuthContext);

	useEffect(() => {
		dispatch({ type: NAV_REDUCER_GET_NAV_DATA, payload: authData?.user_data });
	}, []);

	return (
		<NavContext.Provider value={{ navData, dispatch }}>{props.children}</NavContext.Provider>
	);
};

export default NavContextProvider;
